/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const CustomCheckbox = styled.div`
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    display: flex;
    border: 1px solid ${(props) => props.theme.lightGreyLink40};
    color: ${(props) => props.theme.blackLink};
    background-color: ${(props) => props.theme.white};
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 8px;

    ${({ checked, contrastTheme, disabled }) =>
        checked && !contrastTheme
            ? `
        background: #EC6E0C;
        border-color: #EC6E0C;
        color: #FFFFFF;
    `
            : !checked && contrastTheme && !disabled
            ? `
        background: #000000;
        border-color: #FFF333;
    `
            : checked && contrastTheme
            ? `
        background: #FFF333;
        border-color: #FFF333;
        color: #000000;
    `
            : disabled && !contrastTheme
            ? `
        background: #5B5B5F33;
        border: transparent !important;
        cursor: not-allowed !important;

        & span {
            color: ${(props) => props.theme.lightGrey40}
        };
    `
            : disabled && contrastTheme
            ? `
        background: #000000;
        border: solid 1px #FFFFFF !important;
        cursor: not-allowed !important;

        & span {
            color: ${(props) => props.theme.lightGrey40};
        }
    `
            : `
        background: ${(props) => props.theme.white};
        border-color: ${(props) => props.theme.lightGreyLink40};
    `}

    ${({ error }) => error && `border-color: ${(props) => props.theme.red};`}

    & span {
        font-size: ${theme.font.size16};
        color: ${(props) => props.theme.white}; 
        background: ${(props) => props.theme.orangeLink};
    }
`;
